import React, { FunctionComponent } from "react";
import makeStyles from '@mui/styles/makeStyles';
import cs from "classnames";
import { LocationDistanceTableRecord, MarPointTableRecord, PointTable } from "/src/domain/challenges/ChallengeProtocolData";
import { LocationDistanceTable } from "./locationDistance/LocationDistanceTable";
import { MarPointsTable } from "./marPoints/MarPointsTable";
import { ProgressTable } from "./progressTable/ProgressTable";

export type PointTablesContainerProps = {
    className?: string,
    pointTables: PointTable[]
};

export const PointTablesContainer: FunctionComponent<PointTablesContainerProps> = ({ className, pointTables }) => {
    const classes = useStyles();

    return (<div className={cs(className, classes.container)}>
        {pointTables.map(t => getTableComponent(t))}
    </div>);
};

const getTableComponent = (table: PointTable) => {
    if (table.name === 'location_distance') {
        return <LocationDistanceTable key={'location_distance'} records={table.records as LocationDistanceTableRecord[]} />;
    }

    if (table.name === 'mar_points_table') {
        return <MarPointsTable key={'mar_points_table'} records={table.records as MarPointTableRecord[]} />
    }

    if (table.name === 'progress_table') {
        return <ProgressTable key={'progress_table'} records={table.records as MarPointTableRecord[]} title={table.title} />
    }

    return null;
}

const useStyles = makeStyles({
    container: {}
})